.dropdown {
  border: none;
  min-width: 194px;
  background-color: light-dark(var(--mantine-color-white), var(--mantine-color-primaryDark-8));
}

.item {
  color: light-dark(var(--mantine-color-secondary-9), var(--mantine-color-primaryDark-2));

  &:hover {
    background-color: light-dark(var(--mantine-color-gray-1), var(--mantine-color-dark-4));
  }
}
